import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.256 2.248c-.009.009-.016 1.25-.016 2.76v2.744h1.992v3.48l-3.99.006-3.99.006-.006 2.502-.006 2.502H1.248v5.52l2.754-.006 2.754-.006.006-2.754.006-2.754H4.752v-3.48h6.48v3.48H9.24l.006 2.754.006 2.754h5.496l.006-2.754.006-2.754h-1.992v-3.48h6.48v3.48h-2.016l.006 2.754.006 2.754 2.754.006 2.754.006v-5.52H20.76l-.006-2.502-.006-2.502-3.99-.006-3.99-.006v-3.48h1.992l-.006-2.754-.006-2.754-2.738-.006c-1.506-.003-2.745.001-2.754.01m1.496 2.756V6.24h2.496V3.768h-2.496zM2.76 18.996v1.236h2.472V17.76H2.76zm7.992 0v1.236h2.496V17.76h-2.496zm8.016 0v1.236h2.472V17.76h-2.472z"
    }, null, -1)
  ])))
}
export default { render: render }